import angular from 'angular';
import _ from 'lodash';
import template from './criteriaTagView.html';
import {
    INCLUDED, EXCLUDED, CURRENTLY_NOT, ALL_NOT,
} from '../../constants/tagAdditionalText';

export class CriteriaTag {
    /* @ngInject */
    constructor(TFTTagsService) {
        this.tftTagsService = TFTTagsService;
    }

    $onChanges() {
        const mandatoryIndex = _.get(this.requiredIndexes, `${this.selectedIndex}.requiredValue`, 0);
        const priority = _.get(this.mandatoryValues, `${mandatoryIndex}.value`, '');
        let additionalValue = _.get(this.selectedTag, 'additional.value', false);
        if (!additionalValue) {
            additionalValue = _.get(this.selectedTag, 'additional.text', '');
        }
        const uid = _.get(this.selectedTag, 'additional.uid', '');
        const { className, styles } = this.tftTagsService.getTagStyles({
            priority,
            isExcluded: additionalValue && [EXCLUDED, CURRENTLY_NOT, ALL_NOT].includes(additionalValue),
        });
        const additionalClassName = this.selectedTag.status ? (`${this.selectedTag.status}Filter`) : '';

        this.styles = styles;
        this.className = `${className} ${additionalClassName}`;
        this.additionalText = this.hideAdditional
            ? ''
            : (!additionalValue || [INCLUDED, EXCLUDED, CURRENTLY_NOT, ALL_NOT].includes(additionalValue) ? '' : `, ${additionalValue}`);
        this.additionalValue = additionalValue || uid || INCLUDED;
    }
}

export const CriteriaTagConfiguration = {
    template,
    bindings: {
        selectedTag: '<',
        selectedIndex: '<',
        popupViewIndex: '<',
        requiredIndexes: '<',
        disable: '<',
        setAsMandatory: '<',
        showSettingsPopup: '<',
        hasPreferred: '<',
        mandatoryValues: '<',
        dynamicSubCriteriaData: '<',
        settingsHandler: '&',
        removeValue: '&',
        setRequiredSubCriteria: '&',
        hideAdditional: '<',
    },
    controller: CriteriaTag,
    controllerAs: 'criteriaTagCtrl',
};

angular.module('TALENYA-FE').component('criteriaTag', CriteriaTagConfiguration);
